var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 34,
    viewBox: "0 0 30 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 6.88333H16.7833V14.0167H14.4M20.95 6.88333H23.3333V14.0167H20.95M6.66667 0.333332L0.716675 6.28333V27.7167H7.85001V33.6667L13.8167 27.7167H18.5667L29.2833 17V0.333332M26.9 15.8167L22.15 20.5667H17.3833L13.2167 24.7333V20.5667H7.85001V2.71667H26.9V15.8167Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitch);
export default __webpack_public_path__ + "static/media/TWITCH.d452301e797893fe6902a8c49bea0511.svg";
export { ForwardRef as ReactComponent };